import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import API from "../../apiService.js";
import moment from "moment";
import Barcode from "react-barcode";
import RujukBalik from "../form/RujukBalik";

export class RujukanToPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment(new Date()).format("DD-MM-YYYY"),
    };
  }
  render() {
    // console.log(this.props);
    let birthDate = moment(this.props.patient.tglLahir, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    let age = moment().diff(birthDate, "years");
    return (
      <div>
        <table
          style={{
            fontSize: "12pt",
            margin: 2,
          }}
          width={"99%"}
          frame={"box"}
          // border={1}
        >
          <tbody>
            <tr>
              <td style={{ width: "50%" }} rowSpan={2} colSpan={3}>
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/img/brand/logo-bpjs.png"
                  }
                  width="200px"
                  height="60px"
                />
              </td>
              <td colSpan={2}>
                <h4>Kadeputian Wilayah</h4>
              </td>
              <td>
                :{" "}
                {this.props.patient !== ""
                  ? this.props.patient.ppk.kc.kdKR.nmKR
                  : ""}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <h4>Kantor Cabang </h4>
              </td>
              <td>
                :{" "}
                {this.props.patient !== ""
                  ? this.props.patient.ppk.kc.nmKC
                  : ""}{" "}
              </td>
            </tr>
            <tr>
              <td align={"center"} colSpan={6}>
                <h4>Surat Rujukan FKTP</h4>
              </td>
            </tr>
            <tr>
              <td colSpan={6}>
                <table
                  width={"95%"}
                  frame={"box"}
                  style={{
                    marginTop: "1%",
                    marginLeft: "2%",
                    marginRight: "2%",
                    marginBottom: "1%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td style={{ width: "25%" }}>No. Rujukan</td>
                      <td style={{ width: "25%" }}>
                        :{" "}
                        {this.props.patient !== ""
                          ? this.props.patient.noRujukan
                          : ""}{" "}
                      </td>
                      <td rowSpan={3} align={"center"}>
                        <Barcode
                          height={40}
                          displayValue={false}
                          width={2}
                          value={
                            this.props.patient !== "1"
                              ? this.props.patient.noRujukan
                              : ""
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>FKTP</td>
                      <td>
                        :{" "}
                        {this.props.patient !== ""
                          ? this.props.patient.ppk.nmPPK
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>Kabupaten / Kota</td>
                      <td>
                        :{" "}
                        {this.props.patient !== ""
                          ? this.props.patient.ppk.kc.dati.nmDati
                          : ""}{" "}
                        (
                        {this.props.patient !== ""
                          ? this.props.patient.ppk.kc.dati.kdDati
                          : ""}
                        ){" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ marginLeft: "3%" }}>Kepada Yth. TS Dokter</td>
              <td colSpan={5}>
                :{" "}
                {this.props.px !== ""
                  ? this.props.px.refferal
                    ? this.props.px.refferal.sub.specialist ?this.props.px.refferal.sub.specialist.name :''
                    : ""
                  : ""}{" "}
              </td>
            </tr>
            <tr>
              <td>Di</td>
              <td colSpan={5}>
                :{" "}
                {this.props.px !== ""
                  ? this.props.px.refferal
                    ? this.props.px.refferal.provider ? this.props.px.refferal.provider.name : ''
                    : ""
                  : ""}
              </td>
            </tr>
            <tr>
              <td colSpan={6}>
                Mohon pemeriksaan dan penanganan lebih lanjut pasien :
              </td>
            </tr>
            <tr>
              <td>Nama</td>
              <td>
                : {this.props.patient !== "" ? this.props.patient.nmPst : ""}
              </td>
              <td>Umur:</td>
              <td>{age}</td>
              <td>Tahun:</td>
              <td>
                {this.props.patient !== "" ? this.props.patient.tglLahir : ""}
              </td>
            </tr>
            <tr>
              <td>No. Kartu BPJS</td>
              <td>
                : {this.props.patient !== "" ? this.props.patient.nokaPst : ""}{" "}
              </td>
              <td>Status:</td>
              <td colSpan={2}>
                <input
                  type="text"
                  size={2}
                  readOnly
                  value={
                    this.props.patient !== "" ? this.props.patient.pisa : ""
                  }
                />{" "}
                Utama/tanggungan
              </td>

              <td>
                <input
                  type="text"
                  size={2}
                  readOnly
                  value={
                    this.props.patient !== "" ? this.props.patient.sex : ""
                  }
                />
                (L/P)
              </td>
            </tr>
            <tr>
              <td>Diagnosa</td>
              <td colSpan={5}>
                :{" "}
                {this.props.patient !== ""
                  ? `${this.props.patient.diag1.kdDiag}-${this.props.patient.diag1.nmDiag}`
                  : ""}
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                {this.props.patient !== ""
                  ? this.props.patient.diag2 !== null
                    ? `${this.props.patient.diag2.kdDiag}-${this.props.patient.diag2.nmDiag}`
                    : ""
                  : ""}
              </td>
              <td colSpan={2} style={{ textAlign: "right" }}>
                Catatan:
              </td>
              <td colSpan={2}>
                {this.props.patient !== "" ? this.props.patient.catatan : ""}
              </td>
            </tr>
            <tr>
              <td></td>
              <td colSpan={4}>
                {this.props.patient !== ""
                  ? this.props.patient.diag3 !== null
                    ? `${this.props.patient.diag3.kdDiag}-${this.props.patient.diag3.nmDiag}`
                    : ""
                  : ""}
              </td>
            </tr>
            <tr>
              <td>Telah Diberikan</td>
              <td colSpan={5}>: </td>
            </tr>
            <tr>
              <td colSpan={6}>
                {" "}
                <br /> <br /> <br />
              </td>
            </tr>
            <tr>
              <td colSpan={6}>Atas bantuannya, diucapkan terima kasih</td>
            </tr>
            <tr>
              <td colSpan={4}> </td>
              <td colSpan={2}>Salam Sejawat, {this.state.date} </td>
            </tr>
            <tr>
              <td>Tgl. Rencana Berkunjung</td>
              <td colSpan={5}>
                :{" "}
                {this.props.patient !== ""
                  ? this.props.patient.tglEstRujuk
                  : ""}
              </td>
            </tr>
            <tr>
              <td>Jadwal Praktek</td>
              <td colSpan={5}>
                : {this.props.patient !== "" ? this.props.patient.jadwal : ""}
              </td>
            </tr>
            <tr>
              <td></td>
              <td colSpan={3}></td>
              <td colSpan={2}>
                {this.props.patient !== ""
                  ? this.props.patient.dokter.nmDokter
                  : ""}
              </td>
            </tr>
            <tr>
              <td colSpan={6}>
                Surat Rujukan ini berlaku 1[satu] kali kunjungan, berlaku sampai
                dengan:{" "}
                {this.props.patient !== ""
                  ? this.props.patient.tglAkhirRujuk
                  : ""}
              </td>
            </tr>
          </tbody>
        </table>
        <RujukBalik
          nama={this.props.patient !== "" ? this.props.patient.nmPst : ""}
        />
      </div>
    );
  }
}

export default class PrintRujukan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
    };
  }
  componentDidMount() {
    this.getRujukan();
  }
  getRujukan = async (e) => {
    const res = await API.get(
      "/pcare/kunjungan/rujukan/" + this.props.patient.id
    );
    if (res) {
      if (res.metaData?.code === 200) {
        this.setState({
          data: res.response,
        });
      } else {
        console.error("Cannot load data from remote source");
      }
    }
  };
  render() {
    console.log(this.props.patient);
    return (
      <div>
        <div
          className="alert alert-default  alert-dismissible fade show row"
          role="alert"
        >
          <span className="alert-icon">
            <i className="bus-front-12" />
          </span>
          <span className="alert-text">
            <strong>
              {" "}
              {this.props.patient !== ""
                ? this.props.patient.refferal ? this.props.patient.refferal.provider
                  ? this.props.patient.refferal.provider.name
                  : "" : ''
                : ""}{" "}
            </strong>{" "}
            BAGIAN : {this.state.data !== "" ? this.state.data.poli.nmPoli : ""}
            , Tanggal Rencana Berkunjung :{" "}
            {this.state.data !== "" ? this.state.data.tglEstRujuk : ""}
          </span>
          <div style={{ marginLeft: "1%" }}>
            {/* <ReactToPrint
              trigger={() => (
                <a href="#"> */}
                  <button className="btn btn-primary" type="button" onClick= {()=>this.props.cetak()}>Cetak Rujukan</button>
                {/* </a>
              )}
              content={() => this.componentRef}
            /> */}
            {/* <div style={{ display: "none" }}> */}
              {/* <RujukanToPrint
                ref={(el) => (this.componentRef = el)}
                patient={this.state.data ? this.state.data : ""}
                px={this.props.patient ? this.props.patient : ""}
              />{" "} */}
            {/* </div> */}
          </div>
          <div style={{ marginLeft: "1%" }}>
            <button
              className="btn btn-info"
              type="button"
              onClick={this.props.ModalShow}
            >
              ubah
            </button>
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
    );
  }
}
